import { render, staticRenderFns } from "./IncidentsSideBar.vue?vue&type=template&id=b658d178&"
import script from "./IncidentsSideBar.vue?vue&type=script&lang=js&"
export * from "./IncidentsSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports